export class FleetNavigationModule {
    static get Dashboards(): string { return 'app.dashboard' }
    static get Vehicles(): string { return 'app.fleet.vehicles'; }
    static get VehiclesNew(): string { return 'app.fleet.vehiclesnew'; }
    static get Drivers(): string { return 'app.fleet.drivers'; }
    static get DriverView(): string { return `${FleetNavigationModule.Drivers}.view`; }
    static get Drivers_Old(): string { return 'app.fleet.drivers_old'; }
    static get Messages(): string { return 'app.fleet.messages'; }
    //static get Compliance(): string { return 'app.fleet.compliance'; }
    static get Tachograph(): string { return 'app.fleet.tachograph'; }
    static get Breathalock(): string { return 'app.fleet.breathalock'; }
    static get Temperature(): string { return 'app.fleet.temperature'; }
    static get Maintenance(): string { return 'app.fleet.maintenance'; }

    static get Planning(): string { return "app.fleet.planning"; }

    static get Default(): string { return this.Dashboards; }
    static get ParentRoot(): string { return "app.fleet"; }

    // Todo - Move out of here
    static get Geofences(): string { return 'app.geofences'; }
    //static get Reports(): string { return 'app.reports'; }
    static get ResourceManagement(): string { return 'app.components_resourceManagement'; }
}
